import React from 'react';
import './Container.css';

const Container = ({ children, maxWidth = 'xl', className = '' }) => {
    return (
        <div className={`container container--${maxWidth} ${className}`}>
            {children}
        </div>
    );
};

export default Container;
